import React from 'react';
import styles from './SegmentControl.module.scss';

export interface SegmentControlInterface {
  headers: string[];
  active: number;
  setActive: (index: number) => void;
  content: React.ReactElement | string | number;
}

export const SegmentControl = ({ headers = [], active, setActive, content }: SegmentControlInterface) => (
  <div className={styles.root}>
    <div className={styles.segmentContainer}>
      {headers.map((header, i) => (
        <button
          key={header}
          type="button"
          role="tab"
          aria-selected="false"
          aria-controls="panel-2"
          id="tab-2"
          tabIndex={0}
          className={`${styles.segment} ${active === i ? styles.active : styles.inactive}`}
          onClick={() => {
            setActive(i);
          }}
        >
          {header}
        </button>
      ))}
    </div>
    {content}
  </div>
);
